import { defineStore } from 'pinia';
import { useStorage } from '@vueuse/core';
import {updateConversationIsView} from '/@/api/chat';
export const useSearchState = defineStore('search-store', {
	state: () => ({
		isMessageRight: true,
		activeCitations: '',
		files: [] as any[],
		chatQuote: null as any,
		inputValue: '',
		quoteMessageId: null as string | null,
		autoPreviewFile: null as any,
		previewingFileUrl: null as string | null,
		showSharePopover: null as boolean | null,
		effort: 'standard' as 'standard' | 'high_effort',
		// mode: 'EXPLORATION_MODE' as 'EXPLORATION_MODE' | 'AGENT_MODE',
		mode: 'AGENT_LOOP_MODE',
		// mode: useStorage('search-mode', 'AGENT_MODE' as 'AGENT_MODE' | 'EXPLORATION_MODE'),
		networking: useStorage('search-networking', 0 as 0 | 1),
		webSourceList: useStorage('search-webSourceList', [] as any[]),
		mcpServerIds: useStorage('search-mcpServerIds', [] as any[]),
		knowledgeBaseIds: useStorage('search-knowledgeBaseIds', [] as any[]),
		webSource: useStorage('search-webSource', '1' as string | null),
		skillNames: useStorage('search-skillNames', [] as string[]),
		// taskType: useStorage('search-taskType', null as string | null),
	}),
	getters: {
		filePreviewUrlMap: (state) => Object.fromEntries(state.files.map((file, index) => [index, { previewUrl: file.previewUrl }])),
		allCompleteFiles: (state) => !state.files.some((file) => file.status !== 'success'),
	},
	actions: {
		removeDuplicateStages(data: any) {
			const map = new Map();
			data.forEach((item: any) => {
				map.set(item.stageId, item); // 根据 stageId 存储最新的对象
			});

			return Array.from(map.values()); // 返回只包含最后一个对象的数组
		},
		afterSendQuestion() {
			this.files = [];
			this.chatQuote = null;
			this.quoteMessageId = null;
			this.effort = 'standard';
		},

		fileAdded(file: any) {
			this.files.unshift(file);
		},

		fileIdGenerated({ tempId, realId }: { tempId: string; realId: string }) {
			const file = this.files.find((f) => f.id === tempId);
			if (file) file.id = realId;
		},

		fileRemoved(fileId: string) {
			this.files = this.files.filter((f) => f.id !== fileId);
		},

		fileProgressUpdated({ id, progress }: { id: string; progress: number }) {
			const file = this.files.find((f) => f.id === id);
			if (file) {
				file.status = progress === 100 ? 'pending' : 'uploading';
				file.progress = progress;
			}
		},

		fileCompleted({ id, url }: { id: string; url: string }) {
			const file = this.files.find((f) => f.id === id);
			if (file) {
				file.status = 'success';
				file.error = undefined;
				file.url = url;
				file.previewUrl = undefined;
			}
		},

		fileFailed({ id, error, disableRetry }: { id: string; error: any; disableRetry?: boolean }) {
			const file = this.files.find((f) => f.id === id);
			if (file) {
				file.status = 'error';
				file.error = error;
				file.progress = 0;
				if (disableRetry) file.disableRetry = true;
			}
		},

		fileRetry({ id }: { id: string }) {
			const file = this.files.find((f) => f.id === id);
			if (file) {
				file.status = 'uploading';
				file.error = undefined;
				file.progress = 0;
			}
		},

		filesCleared() {
			this.files = [];
		},

		setInputValue(value: string) {
			this.inputValue = value;
		},

		quoteMessage(messageId: string) {
			this.quoteMessageId = messageId;
		},

		autoPreviewFileSetter(file: any) {
			this.autoPreviewFile = file;
		},

		setPreviewingFileUrl(url: string) {
			this.previewingFileUrl = url;
		},

		setShowSharePopover(show: boolean) {
			this.showSharePopover = show;
		},

		setEffort(value: 'standard' | 'high_effort') {
			this.effort = value;
		},
		// setMode(value: 'AGENT_MODE' | 'EXPLORATION_MODE') {
		// 	this.mode = value;
		// },
		setMode(value: 'AGENT_LOOP_MODE' | 'AGENT_LOOP_FAST_MODE') {
			this.mode = value;
		},
		setNetworking(value: 0 | 1) {
			this.networking = value;
		},
		setWebSourceList(value: []) {
			this.webSourceList = value;
		},
		setMcpServerIds(value: []) {
			this.mcpServerIds = value;
		},
		setKnowledgeBaseIds(value: []) {
			this.knowledgeBaseIds = value;
		},
        setSkillNames(value: string[]) {
			this.skillNames = value;
		},
		setTaskType(value:string|null) {
			this.taskType = value;
		},

		setWebsource(value: string) {
			this.webSource = value;
		},

		setChatQuote(quote: any) {
			this.chatQuote = quote;
		},
		//更新会话已读状态
		async updateConversationIsViewStatus(conversationId:string,dialogueId:string) {
			let data={
				id:conversationId,
				dialogueId:dialogueId
			}
			updateConversationIsView(data)
		},
	},
});

